import { escapeRegExp, forEach, isEmpty, keys } from 'lodash';

import {
    DisplayListItem,
    DisplayRegion,
    SelectedScreens
} from '../../../typings/displayMap';
import { selectedFilters as easySelectedFilters } from '../../EasyFilters/EasyFilters';

export const IndoorUtils = {
    getFilters: (screenGroupsByRegion: { [id: string]: DisplayListItem[] }) => {
        const zoneCategory = {};
        const facilityType = {};

        forEach(screenGroupsByRegion, (groups: DisplayListItem[]) => {
            groups.forEach((group: DisplayListItem) => {
                if (!zoneCategory[group.zoneCategory]) {
                    zoneCategory[group.zoneCategory] = true;
                }

                if (!facilityType[group.facilityType]) {
                    facilityType[group.facilityType] = true;
                }
            });
        });

        return {
            zoneCategory: keys(zoneCategory),
            facilityType: keys(facilityType)
        };
    },

    filterScreenGroups: (
        screenGroupsByRegion: { [id: string]: DisplayListItem[] },
        selectedFilters: { [name: string]: easySelectedFilters },
        filteredRegions: DisplayRegion[],
        selectedScreens: SelectedScreens,
        searchText: string
    ) => {
        return filteredRegions.reduce(
            (
                result: { [id: string]: DisplayListItem[] },
                region: DisplayRegion
            ) => {
                result[region.id] = IndoorUtils.filterRegion(
                    screenGroupsByRegion[region.id],
                    selectedFilters,
                    selectedScreens[region.id] || [],
                    searchText
                );

                return result;
            },
            {}
        );
    },

    filterRegion: (
        groups: DisplayListItem[],
        selectedFilters: { [name: string]: easySelectedFilters },
        selectedScreens: string[],
        searchText: string
    ): DisplayListItem[] => {
        if (selectedFilters.selected) {
            groups = groups.filter((group: DisplayListItem) => {
                return selectedScreens.includes(group.id);
            });
        }

        if (!isEmpty(selectedFilters.zoneCategory)) {
            groups = groups.filter((group: DisplayListItem) => {
                // TODO избавится от toString
                const zoneCategory = group.zoneCategory.toString();

                if (Array.isArray(selectedFilters.zoneCategory)) {
                    return selectedFilters.zoneCategory.includes(zoneCategory);
                } else {
                    return false;
                }
            });
        }

        if (!isEmpty(selectedFilters.facilityType)) {
            groups = groups.filter((group: DisplayListItem) => {
                // TODO избавится от toString
                const facilityType = group.facilityType.toString();

                if (Array.isArray(selectedFilters.facilityType)) {
                    return selectedFilters.facilityType.includes(facilityType);
                } else {
                    return false;
                }
            });
        }

        if (searchText) {
            const regExpTest: RegExp = new RegExp(
                escapeRegExp(searchText),
                'i'
            );

            groups = groups.filter((displayListItem: DisplayListItem) => {
                const title = displayListItem.caption.toString();
                const subtitle = displayListItem.address.toString();
                const id = displayListItem.id.toString();
                const gid = displayListItem.gid;
                const operatorName =
                    'operatorName' in displayListItem
                        ? displayListItem.operatorName
                        : undefined;

                return (
                    regExpTest.test(title) ||
                    regExpTest.test(subtitle) ||
                    regExpTest.test(id) ||
                    (gid && regExpTest.test(gid)) ||
                    (operatorName && regExpTest.test(operatorName))
                );
            });
        }

        return groups;
    }
};
